import React from "react";

import { CellInput } from "./CellInput/CellInput";
import { Wrapper } from "./styled";
import OTPInput from "react-otp-input";

export const CodeInput = ({
  value,
  onChange,
  type = "number",
  error,
  size = 4,
}) => {
  return (
    <Wrapper>
      <OTPInput
        value={value}
        onChange={onChange}
        numInputs={size}
        inputType={type}
        containerStyle={{
          gap: "clamp(12px, 3vw, 24px)",
          width: "100%",
        }}
        renderInput={(props) => <CellInput error={error} {...props} />}
      />
    </Wrapper>
  );
};
